import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import {FaBell, FaExclamationTriangle } from 'react-icons/fa';
import './update.css';

const ImportantUpdates = () => {
  const [updates, setUpdates] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get("https://backend.aubattle.com/api/updates")
      .then((res) => {
        setUpdates(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching updates", err);
        setIsLoading(false);
      });
  }, []);

  const toggleUpdate = (id) => {
    setOpenId(prevId => (prevId === id ? null : id));
  };

  const getPriorityClass = (priority) => {
    switch(priority) {
      case 'high': return 'priority-high';
      case 'medium': return 'priority-medium';
      default: return 'priority-low';
    }
  };

  return (
    <div className="gb-updates-container">
         <button 
            className="back-btn"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-chevron-left"></i> Back
          </button>
      <div className="gb-updates-header">
        <div className="gb-title-section">
          <FaBell className="gb-title-icon" />
          <h1>GAMEZONE UPDATES</h1>
          <span className="gb-updates-count">{updates.length} ALERTS</span>
        </div>
        <p className="gb-subtitle">Official announcements, patch notes, and tournament updates</p>
      </div>

      {isLoading ? (
        <div className="gb-loading">
          <div className="gb-spinner"></div>
          <p>Loading updates...</p>
        </div>
      ) : updates.length === 0 ? (
        <div className="gb-empty-state">
          <FaExclamationTriangle className="empty-icon" />
          <p>No updates available at this time</p>
        </div>
      ) : (
        <div className="gb-updates-list">
          {updates.map((update) => (
            <div 
              key={update.id} 
              className={`gb-update-card ${getPriorityClass(update.priority)} ${openId === update.id ? 'active' : ''}`}
            >
              <div 
                className="gb-update-header"
                onClick={() => toggleUpdate(update.id)}
              >
                <div className="gb-update-meta">
                  <span className="gb-update-date">
                    {new Date(update.created_at).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric'
                    })}
                  </span>
                  <span className={`gb-priority ${getPriorityClass(update.priority)}`}>
                    {update.priority || 'standard'}
                  </span>
                </div>
                <h3 className="gb-update-title">{update.heading}</h3>
                <div className="gb-toggle-indicator">
                  {openId === update.id ? '▲' : '▼'}
                </div>
              </div>

              {openId === update.id && (
                <div className="gb-update-content">
                  <div className="gb-update-body">
                    <p>{update.description || update.content}</p>
                  </div>
                  <div className="gb-update-footer">
                    <span className="gb-update-id">Update ID: {update.id}</span>
                    {update.link && (
                      <a 
                        href={update.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="gb-update-link"
                      >
                        View Details
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImportantUpdates;